export const formatPercentage = (num) => {
  if (num === null || num === undefined || Number.isNaN(num)) {
    return '';
  }
  
  if (Number.isInteger(num)) {
    return `${num}%`;
  }
  
  return `${num.toFixed(2)}%`;
};